var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlmacenajeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAdicionales/Almacenaje"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconAdicionales/Almacenaje_2",
    d: "M25.4848 17.1871H7.53475C7.31989 17.1871 7.1441 17.3629 7.1441 17.5778L7.13922 19.9216C7.13922 20.1365 7.31501 20.3123 7.52987 20.3123H25.4848C25.6997 20.3123 25.8755 20.1365 25.8755 19.9216V17.5778C25.8755 17.3629 25.6997 17.1871 25.4848 17.1871ZM25.4848 21.8748H7.5201C7.30524 21.8748 7.12946 22.0506 7.12946 22.2655L7.12457 24.6094C7.12457 24.8242 7.30036 25 7.51522 25H25.4848C25.6997 25 25.8755 24.8242 25.8755 24.6094V22.2655C25.8755 22.0506 25.6997 21.8748 25.4848 21.8748ZM25.4848 12.4994H7.54451C7.32966 12.4994 7.15387 12.6752 7.15387 12.89L7.14899 15.2339C7.14899 15.4488 7.32478 15.6245 7.53963 15.6245H25.4848C25.6997 15.6245 25.8755 15.4488 25.8755 15.2339V12.89C25.8755 12.6752 25.6997 12.4994 25.4848 12.4994ZM30.6853 5.71195L17.3985 0.179455C17.1129 0.0609821 16.8068 0 16.4976 0C16.1884 0 15.8823 0.0609821 15.5967 0.179455L2.31477 5.71195C1.44558 6.07818 0.874268 6.92783 0.874268 7.87514V24.6094C0.874268 24.8242 1.05006 25 1.26491 25H5.17135C5.38621 25 5.562 24.8242 5.562 24.6094V12.4994C5.562 11.64 6.27492 10.9368 7.15387 10.9368H25.8462C26.7251 10.9368 27.4381 11.64 27.4381 12.4994V24.6094C27.4381 24.8242 27.6138 25 27.8287 25H31.7351C31.95 25 32.1258 24.8242 32.1258 24.6094V7.87514C32.1258 6.92783 31.5545 6.07818 30.6853 5.71195Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmacenajeIcon);
export default __webpack_public_path__ + "static/media/almacenaje_icon.589ff502b07eb641b2977985f32608fe.svg";
export { ForwardRef as ReactComponent };